/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2025-05-21 10:41:18
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2025-07-29 14:23:23
 * @FilePath: \crane-safety-manager\src\Common\Spinner.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React, { useEffect } from "react"

const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 50,
      }}
      spin
    />
  );

const Spinners = ({ setLoading }) => {

  useEffect(() => {
    setLoading(false)
  }, [setLoading]);

  return (
      <React.Fragment>
          <Spin indicator={antIcon} style={{display: "flex", alignSelf: "center", paddingLeft: "50%", paddingTop: "10%" }} />
      </React.Fragment>
  )
}

export default Spinners;